import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=47872c8d&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=47872c8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47872c8d",
  null
  
)

export default component.exports